module.exports = __webpack_public_path__ + "img/adulto.2180f0f6.svg";